import { Component, OnInit, forwardRef } from "@angular/core";
import {
  NavController,
  AlertController,
  ToastController,
  LoadingController,
  ActionSheetController,
  ModalController,
  NavParams,
  IonicModule,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { BuscarPessoaPage } from "../../buscar-pessoa/buscar-pessoa.page";
import { AcompanhamentoProvider } from "src/app/services/acompanhamento/acompanhamento";
import { AcompanhamentoAddRespPage } from "../acompanhamento-add-resp/acompanhamento-add-resp.page";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";

import { ImagePipe } from "src/app/pipes/image/image";

@Component({
  selector: "app-acompanhamento-add-part",
  templateUrl: "./acompanhamento-add-part.page.html",
  styleUrls: ["./acompanhamento-add-part.page.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, TranslateModule, ImagePipe, SemRegistroComponent],
})
export class AcompanhamentoAddPartPage implements OnInit {
  acompanhamento: any;
  participanteList: any = [];
  participantesTempList: any = [];
  constructor(
    public navCtrl: NavController,
    public alertCtrl: AlertController,
    private translate: TranslateService,
    public toastCtrl: ToastController,
    public loadingController: LoadingController,
    public acompanhamentoProvider: AcompanhamentoProvider,
    public actionSheetCtrl: ActionSheetController,
    public modalCtrl: ModalController,
    public navParams: NavParams
  ) {
    this.acompanhamento = this.navParams.get("acompanhamento");
    if (this.navParams.get("participantes")) {
      this.participanteList = this.navParams.get("participantes");
      this.participantesTempList = [...this.participanteList];
    }
  }

  ngOnInit() {}

  async add() {
    var modalPessoa = await this.modalCtrl.create({
      component: BuscarPessoaPage,
      componentProps: { buscarGeral: true, adiciona: true },
    });
    modalPessoa.present();

    const { data } = await modalPessoa.onWillDismiss();
    if (data.pessoa) {
      if (!this.participantesTempList.find((participante: { id: string }) => participante.id == data.pessoa.id)) {
        this.participantesTempList.push(data.pessoa);
      }
    }
  }

  async selecionarPessoa(pessoa: any) {
    let actionSheet = await this.actionSheetCtrl.create({
      header: this.translate.instant("Opções"),
      buttons: [
        {
          text: this.translate.instant("Remover Pessoa"),
          handler: async () => {
            let alert = await this.alertCtrl.create({
              cssClass: "alerta-personalizado",
              mode: "ios",
              header: this.translate.instant("Atenção"),
              message: this.translate.instant("Deseja remover essa pessoa desse acompanhamento?"),
              buttons: [
                {
                  text: this.translate.instant("Não"),
                  handler: () => {},
                },
                {
                  text: this.translate.instant("Sim"),
                  handler: () => {
                    this.participantesTempList.splice(this.participantesTempList.indexOf(pessoa), 1);
                  },
                },
              ],
            });
            alert.present();
          },
        },
      ],
    });

    actionSheet.present();
  }

  async proximo() {
    if (this.participantesTempList.length > 0) {
      const data = { acompanhamento: this.acompanhamento, participantes: this.participantesTempList };

      const modalPage = await this.modalCtrl.create({
        component: AcompanhamentoAddRespPage,
        componentProps: data,
        animated: false,
      });
      modalPage.present();

      const result = await modalPage.onWillDismiss();
      if (result.data) {
        await modalPage.dismiss();
        await this.modalCtrl.dismiss(result.data);
      }
    } else {
      const toast = await this.toastCtrl.create({
        message: this.translate.instant("Erro! Necessário informar no mínimo um participante"),
        duration: 3000,
      });
      toast.present();
    }
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  async salvar() {
    if (this.participantesTempList.length > 0) {
      let ids: any[] = [];
      this.participantesTempList.forEach((part: { id: any }) => {
        ids.push(part.id);
      });

      this.acompanhamentoProvider.salvarPessoa(this.acompanhamento.id, ids, false).subscribe((data) => {
        this.modalCtrl.dismiss(data);
      });
    } else {
      const toast = await this.toastCtrl.create({
        message: this.translate.instant("Erro! Necessário informar no mínimo um participante"),
        duration: 3000,
      });
      toast.present();
    }
  }
}
